import styled from 'styled-components';

import { mediaQueries } from 'theme/mediaQueries';
import { color } from 'theme/selectors';

export const VideoWrapper = styled.video`
    border: 6px solid ${color('border-default')};
    border-radius: 20px;
    width: 190px;
    height: 397px;

    ${mediaQueries.tabletLandscape} {
        width: 217px;
        height: 456px;
    }
`;
